import { useSelector } from "react-redux";
import { RootState } from "configureStore";
import useIsBelowDesktop from "components/layout/use-is-below-desktop";
import { COLLAPSED_W, EXPANDED_W } from "./online-users-panel.constants";

/**
 * The width of the fixed right-hand presence rail (`OnlineUsersPanel`), for
 * anything that has to lay out next to it — a fixed-right panel that must end
 * at the rail's left edge instead of sliding underneath it.
 *
 * The rail only renders when a companyId is in the route (see
 * `OnlineUsersPanel`), and only ever collapsed/expanded to these two widths —
 * this hook mirrors both facts rather than duplicating them at each call site.
 * Below 1024px there is no rail at all: the list opens as a sheet over the
 * page, which takes no room from anything, so the width is 0.
 */
export function usePresenceRailWidth(companyId?: string): number {
  const isPanelExpanded = useSelector((state: RootState) => state.presenceReducer.expanded);
  const isBelowDesktop = useIsBelowDesktop();
  if (!companyId || isBelowDesktop) return 0;
  return isPanelExpanded ? EXPANDED_W : COLLAPSED_W;
}
